document.addEventListener('DOMContentLoaded', function () {
  class ArticleProgressBar extends HTMLElement {
    constructor() {
      super();

      this.progressBar = this.querySelector('.article-progress-bar__fill');
      this.article = document.querySelector('#main-article-content');

      this.handleScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
      this.handleScroll(); 
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }

    onScroll() {
      const article = this.article || document.querySelector('#main-article-content');
      const progressBar = this.progressBar || document.querySelector('#article-progress-bar');

      if (!article || !progressBar) return;

      const scrollTop = window.scrollY || window.pageYOffset;
      const articleTop = article.offsetTop;
      const articleHeight = article.offsetHeight;
      const articleBottom = articleTop + articleHeight;
      const viewportTop = scrollTop;
      const viewportHeight = window.innerHeight;

      // Show progress bar only when article is in viewport (top has reached or passed top, and bottom is still below top)
      const hasReachedTop = viewportTop >= articleTop;
      const hasPassedBottom = viewportTop >= articleBottom;

      if (hasReachedTop && !hasPassedBottom) {
        document.body.classList.add('show-article-progress-bar');
      } else {
        document.body.classList.remove('show-article-progress-bar');
      }

      // Progress calculation
      const earlyOffset = 0;
      const distanceScrolled = scrollTop - (articleTop - earlyOffset);
      const totalScrollable = articleHeight - viewportHeight + earlyOffset;
      const progress = Math.min(100, Math.max(0, (distanceScrolled / totalScrollable) * 100));

      this.classList.toggle('is-sticky', progress !== 0);
      this.style.setProperty('--progress-value', `${progress}%`);
    }

  }
  customElements.define('article-progress-bar', ArticleProgressBar);
});